export default __webpack_public_path__ + "static/media/my_photo.077dca04.jpeg";